<template>
  <div id="carousel" :class="$mq" @keyup.left="next()" @keyup.right="previous()">
    <Detail :range="showDetail.range" v-if="showDetail.show" @close="showDetail.show = false" :key="'detail'"></Detail>
    <div class="carousel-wrapper">
      <h1>{{ $t('Offer.Carousel.title') }}</h1>
      <div class="carousel-offset" :class="{one: items.length === 1}">
        <transition-group class="carousel inline top" :class="[ items.length > 1 ? 'left' : 'center']" name="flip-list" tag="div">
          <div class="product-wrapper" :class="[index === activeIndex ? 'active' : '']" v-for="(item, index) in sortedProducts" :key="item.range" @click="action(index)">
            <div v-if="index !== activeIndex" class="prevent"></div>
            <Product
              class="product"
              :showDisclaimer="!!findDiscountDD"
              :range="item"
              :class="[index === activeIndex ? 'active' : '']"
              @next="$emit('next')"
              @save="save()"
              @showDetail="showDetailModal"
            ></Product>
          </div>
        </transition-group>
      </div>
    </div>
    <div class="carousel-button carousel-button--left" :class="{ one: items.length === 1, TA:isTestAchat }">
      <button @click="next()"><SvgIcon icon="left"></SvgIcon></button>
    </div>
    <div class="carousel-button carousel-button--right" :class="{ one: items.length === 1, TA:isTestAchat }">
      <button @click="previous()"><SvgIcon icon="right"></SvgIcon></button>
    </div>
  </div>
</template>

<script>
import Product from "./Product";
import Detail from "./Detail";
import { mapGetters, mapState } from 'vuex';
import sortedProducts from "@/mixins/sortedProducts";
import getDiscountDom from "@/mixins/getDiscountDom";

export default {
  name: 'Carousel',
  mixins: [sortedProducts, getDiscountDom],
  data() {
    return {
      productHelp: false,
      region: false,
      showDetail: {show: false, range: null}
    }
  },
  props: {
    items: {
      type: Array,
    },
  },
  computed: {
    ...mapGetters("contract", ["anyProduct", "electricityProduct", "gasProduct"]),
    ...mapGetters("common", ["isTestAchat"]),
    ...mapGetters("energy", ["hasElec", "hasGas"]),
    ...mapState("contact", ["isPro"]),
    activeIndex() {
      return this.items.length > 1 ? 1 : 0;
    },
  },
  methods: {
    action(index) {
      if(index < this.activeIndex)
        while(index < this.activeIndex) {
          this.next();
          index++;
        }
      if(index > this.activeIndex)
        while(index > this.activeIndex) {
          this.previous();
          index--;
        }
      this.save();
      this.getDiscountDom(this.sortedProducts[index]);
    },
    next() {
      let tmpItem = this.items.pop();
      this.items.unshift(tmpItem);
    },
    previous() {
      let tmpItem = this.items.shift();
      this.items.push(tmpItem);
    },
    save() {
      this.$store.dispatch("simulation/save", this.items);
    },
    switchProduct(result) {
      let range = 'EASY'

      // Dom  Fix  3
      // 1    1    1 -> Zen
      // 1    1    0 -> Super (fix)
      // 1    0    0 -> Super (var)
      // 0    1    1 -> Zen
      // 0    0    1 -> Easy (fix)
      // 0    0    0 -> Easy (var)

      if(result[0]) {
        range = 'SUPER'

        this.$store.dispatch('offer/changeRangesType', result[1] ? 'fix': 'variable');

        if(result[2]) {
          range = 'ZEN'
        }
      } else {
        this.$store.dispatch('offer/changeRangesType', result[2] ? 'fix': 'variable');

        if(result[1]) {
          range = 'ZEN'
        }
      }

      let index = this.items.findIndex(item => item.range === range);

      this.action(index);

      return range;
    },
    showDetailModal(e) {
      this.showDetail = e;
    }
  },
  created() {
    this.region = this.$store.state.calculation.area;
    this.getDiscountDom(this.sortedProducts[this.activeIndex]);
  },
  components: {
    Product,
    Detail
  },
};
</script>

<style lang="scss" scoped>
#carousel {
  position: relative;
  overflow: hidden;
  margin: 20px 0;

  &.desktop {
    .carousel-wrapper {
      width: 100%;

      .carousel-offset {
        margin: 0;

        .carousel {
          justify-content: center;
        }
      }

      .notice {
        width: 715px;
      }

      .product-wrapper {
        width: 290px;

        &:nth-child(n+4) {
          display: none;
        }
      }
    }

    .carousel-button {
      margin: 0 calc(50% - 165px);
      width: 330px;
      display: none;
    }
  }

  .carousel-wrapper {
    width: 100%;
    overflow: hidden;
    padding-bottom: 10px;

    h1 {
      margin: 0;
      margin-bottom: 20px;
      font-size: 1.7rem;
    }

    .notice {
      display: block;
      margin: 0 auto 15px auto;
      width: 95%;
      text-align: center;
      font-size: 0.8rem;
      line-height: 1.4rem;
    }

    .carousel-offset {
      position: relative;
      width: 100%;
      margin-left: -70%;

      &.one {
        margin-left: 0;
      }
    }

    .carousel {
      flex-wrap: nowrap;
    }
  }

  .carousel-button {
    position: absolute;
    z-index: 12;
    top: 45%;
    margin: 0 5%;

    &.one {
      display: none;
    }

    &.TA {
      button {
        border: 2px solid $pink;
      }

      }

    button {
      height: 40px;
      width: 40px;
      border: 2px solid $yellow;
      border-radius: 50%;
      box-shadow: 0 1px 5px rgba(0, 0, 0, 0.3);
      background: $white;
      cursor: pointer;
    }

    &--left {
      left: 0;
    }
    &--right {
      right: 0;
    }
  }
}

.flip-list-move {
  transition: transform 0.2s;
}

.product-wrapper {
  position: relative;
  width: 80%;
  margin: 0;
  z-index: 9;

  &.active {
    z-index: 10;

    .product {
      opacity: 1!important;
      margin-top: 0!important;
    }
  }
}

.prevent {
  cursor: pointer;
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 10;
  height: 100%;
  width: 100%;
}

.product {
  margin-top: 10px!important;
}

.disclaimer {
  margin: 1rem;
  font-size: 0.7rem;
}
</style>



// WEBPACK FOOTER //
// src/views/simulation/Carousel.vue